import { OrganizationLanguage } from 'src/types/enum/organization-language';
import { useSupabaseAuthProviderService } from '../../services/supabase-auth-provider.service';
import authApi from '../clients/auth';

export const resetCredential = async (
  email: string,
  language: OrganizationLanguage,
) => {
  await authApi.post(
    `/reset-credential`,
    {
      email,
      language,
    },
    {
      skipTenantAttachment: true,
    },
  );
};

export const updatePassword = async (password: string) => {
  const supabaseClient = useSupabaseAuthProviderService.getState().client;

  if (!supabaseClient) {
    throw new Error('Supabase client not found');
  }

  const response = await supabaseClient.auth.updateUser({ password });

  if (response.error) {
    throw response.error;
  }
};

export const setNewCredential = async (
  token: string,
  newCredential: string,
) => {
  await authApi.post(
    `/set-new-credential/${token}`,
    {
      newCredential,
    },
    {
      skipTenantAttachment: true,
    },
  );
};
